<template>
  <div class="Form__group is--date" :class="{ 'is--error' : error }">
    <label :for="id">{{ label }} <abbr v-if="required" title="Requis">*</abbr></label>
    <div class="Date__container">

      <input
        type="date"
        :disabled="disabled"
        v-model="picked"
        :min="min"
        :max="max"
        :required="!!required"
      />
    </div>
    <div class="errors__container">
      <span v-if="error" class="error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import Icon from '@components/Icon'
  import Input from "@components/form/Input";

  export default {
    props : [ 'label', 'name', 'id', 'required', 'error', 'modelValue', 'min', 'max', 'disabled'],
    components : {
      Input,
      Icon
    },
    watch: {
      picked: 'onChange'
    },
    setup(props) {
      const picked = ref(props.modelValue)
      return {
        picked,
      }
    },
    methods: {
      onChange: function (){
        this.$emit('update:modelValue', this.picked)
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/form/_Date.scss";
</style>
